import { makeAutoObservable } from "mobx";

export const MAX_ISSUES_AVAILABLE = 75;

export class Stock {
  //#region defaultProperties
  readonly isInStockStockist: boolean
  readonly stockAvailableForStockist: number
  stockStockistDisplay: string
  //#endregion

  //#region customProperties
  // TODO: this might be temporary solution until we store baskets on the backend
  private _inBasket: number
  set inBasket(value: number) {
    this._inBasket = value
  }

  get inBasket() {
    return this._inBasket
  }

  // #endregion

  // TODO: this might be temporary solution until we store baskets on the backend
  get issuesAvailableIncludingBasket() {
    return this.issuesAvailableInTotal - this._inBasket;
  }

  get issuesAvailableInTotal() {
    return Math.max(
      0,
      Math.min(MAX_ISSUES_AVAILABLE, this.stockAvailableForStockist)
    )
  }

  constructor(
    isInStockStockist: boolean,
    stockAvailableForStockist: number,
    stockStockistDisplay: string,
    _inBasket: number | undefined
  ) {
    this.isInStockStockist = isInStockStockist
    this.stockAvailableForStockist = stockAvailableForStockist
    this.stockStockistDisplay = stockStockistDisplay
    this._inBasket = _inBasket ?? 0

    makeAutoObservable(this)
  }
}